import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["aria-valuenow", "aria-valuetext", "aria-valuemax"]
const _hoisted_2 = ["onMousemove", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "el-rate",
    role: "slider",
    "aria-valuenow": _ctx.currentValue,
    "aria-valuetext": _ctx.text,
    "aria-valuemin": "0",
    "aria-valuemax": _ctx.max,
    tabindex: "0",
    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKey && _ctx.handleKey(...args)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.max, (item, key) => {
      return (_openBlock(), _createElementBlock("span", {
        key: key,
        class: "el-rate__item",
        style: _normalizeStyle({ cursor: _ctx.rateDisabled ? 'auto' : 'pointer' }),
        onMousemove: ($event: any) => (_ctx.setCurrentValue(item, $event)),
        onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetCurrentValue && _ctx.resetCurrentValue(...args))),
        onClick: ($event: any) => (_ctx.selectValue(item))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass([[_ctx.classes[item - 1], { 'hover': _ctx.hoverIndex === item }], "el-rate__icon"]),
          style: _normalizeStyle(_ctx.getIconStyle(item))
        }, [
          (_ctx.showDecimalIcon(item))
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass([_ctx.decimalIconClass, "el-rate__decimal"]),
                style: _normalizeStyle(_ctx.decimalStyle)
              }, null, 6))
            : _createCommentVNode("", true)
        ], 6)
      ], 44, _hoisted_2))
    }), 128)),
    (_ctx.showText || _ctx.showScore)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "el-rate__text",
          style: _normalizeStyle({ color: _ctx.textColor })
        }, _toDisplayString(_ctx.text), 5))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}